import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import axios from "axios";
import data from "../../assets/apiRoutes.json";
import { Popup, ToolbarItem } from 'devextreme-react/popup';
import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
    Export,
    ColumnHeaderFilter,
    ColumnChooser,
    Selection,
} from "devextreme-react/data-grid";

const ItemInventoryStatusPopup = (props) => {
    const [popupState, setPopUpState] = useState(props.visibility);
    const [itemStatusData, setitemStatusData] = useState([]);
    const [itemTotalWeightData, setItemTotalWeightData] = useState([]);
    const jsonString = JSON.stringify(props.itemObj);

    // Log the JSON-formatted string
    console.log(jsonString);
    const [inventoryItemStatusObj, setinventoryItemStatusObj] = useState({
        lotCode: "",
        itemCode: "",
        itemRowid: props.itemObj.itemRowid,
        lotRowid: props.itemObj.lotRowid,
        subLotRowid: props.itemObj.subLotRowid

    });
    var accessToken = props.oidc.user.access_token;
    const columns = ['ItemCode', 'Description-1', 'Description-2', 'Status', 'Class', 'SubClass'];
    const dataItmGrid = [{
        'ItemCode': props.itemObj.itemCode, 'Description-1': props.itemObj.itemDescription1, 'Description-2': props.itemObj.itemDescription2,
        'Status': props.itemObj.itemStatus, 'Class': props.itemObj.classCode, 'SubClass': props.itemObj.subClassCode
    }];

    const hideInfo = () => {
        setPopUpState(false);
        props.parentCallback(false);
    };

    useEffect(() => {
        loadInventoryItemStatusData();
    }, []);
 
    const loadInventoryItemStatusData = () => {
        axios
            .post(`${window._env_.REACT_APP_APIS}/${data.OM.GetItemQuantitySummary}`, inventoryItemStatusObj,
                {
                    headers: {
                        "Content-Type": "application/json",
                        access_token: accessToken,
                        Authorization: `Bearer ${accessToken}`,
                    },
                })
            .then((res) => {
                if (res.data)
                    setitemStatusData(convertData(res.data));
            });
    };
   
    function convertData(data) {
        const calcPackageVal = (val) => {
            return data.itemUnitPerPckgQty ? parseFloat((val / data.itemUnitPerPckgQty).toFixed(2)) : 0.00;
        };
        const calcShipmentVal = (val) => {
            return data.itemUnitPerPckgQty && data.itemPackagesPerShipUnitQty ? ((val / data.itemUnitPerPckgQty) / data.itemPackagesPerShipUnitQty) : 0.00
        };
        var itemOnHand = data.itemOnHand ? data.itemOnHand : 0.00;
        var itemAvailable = data.itemAvailable ? data.itemAvailable : 0.00;
        var itemNetAvailable = data.itemNetAvailable ? data.itemNetAvailable : 0.00;
        var itemInReceiving = data.itemInReceiving ? data.itemInReceiving : 0.00;
        var itemOutShipped = data.itemOutShipped ? data.itemOutShipped : 0.00;
        var itemInOrdered = data.itemInOrdered ? data.itemInOrdered : 0.00;
        var itemOutOrdered = data.itemOutOrdered ? data.itemOutOrdered : 0.00;
        var itemInFuture = data.itemInFuture ? data.itemInFuture : 0.00;
        var itemOutFuture = data.itemOutFuture ? data.itemOutFuture : 0.00;
        var itemOutUnAvailable = data.itemOutUnAvailable ? data.itemOutUnAvailable : 0.00;

        var itemPiecesPerUnitQty = data.itemPiecesPerUnitQty ? data.itemPiecesPerUnitQty : 0.00;

        return [
            {
                title: 'On Hand',
                inventoryUnits: itemOnHand,
                pieces: (itemOnHand * itemPiecesPerUnitQty),
                packages: calcPackageVal(itemOnHand),
                shipment: calcShipmentVal(itemOnHand)
            },
            {
                title: 'In Receiving',
                inventoryUnits: itemInReceiving,
                pieces: (itemInReceiving * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemInReceiving),
                shipment: calcShipmentVal(itemInReceiving)
            },
            {
                title: 'In Shipping',
                inventoryUnits: itemOutShipped,
                pieces: (itemOutShipped * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemOutShipped),
                shipment: calcShipmentVal(itemOutShipped)
            },
            {
                title: 'Unavailable',
                inventoryUnits: itemOutUnAvailable,
                pieces: (itemOutUnAvailable * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemOutUnAvailable),
                shipment: calcShipmentVal(itemOutUnAvailable)
            },
            {
                title: 'Available',
                inventoryUnits: itemAvailable,
                pieces: (itemAvailable * itemPiecesPerUnitQty),
                packages: calcPackageVal(itemAvailable),
                shipment: calcShipmentVal(itemAvailable)
            },
            {
                title: 'Pending Rec',
                inventoryUnits: itemInOrdered,
                pieces: (itemInOrdered * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemInOrdered),
                shipment: calcShipmentVal(itemInOrdered)
            },
            {
                title: 'Pending Ship',
                inventoryUnits: itemOutOrdered,
                pieces: (itemOutOrdered * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemOutOrdered),
                shipment: calcShipmentVal(itemOutOrdered)
            },
            {
                title: 'Net Available',
                inventoryUnits: itemNetAvailable,
                pieces: (itemNetAvailable * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemNetAvailable),
                shipment: calcShipmentVal(itemNetAvailable)
            },
            {
                title: 'Future Rec',
                inventoryUnits: itemInFuture,
                pieces: (itemInFuture * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemInFuture),
                shipment: calcShipmentVal(itemInFuture)
            },
            {
                title: 'Future Ship',
                inventoryUnits: itemOutFuture,
                pieces: (itemOutFuture * data.itemPiecesPerUnitQty),
                packages: calcPackageVal(itemOutFuture),
                shipment: calcShipmentVal(itemOutFuture)
            }
        ]
    }
    return (
        <Popup
            visible={popupState}
            onHiding={hideInfo}
            dragEnabled={false}
            hideOnOutsideClick={true}
            showCloseButton={true}
            showTitle={true}
            title="Status"
            container="#root"
            width="80vw"
            height="90vh"
        >
            <div className="popup-content" style={{ overflow: 'auto', maxHeight: '100%' }}>
                <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                    dataSource={dataItmGrid}
                    defaultColumns={columns}
                    showBorders={true}
                />
                <div className="row" id="inventory-status-grid" style={{ paddingTop: "10px" }}>
                    <div className="col-md-12">
                        <h6 style={{ color: window._env_.Color2 }} >
                            Inventory Quantity Details
                        </h6>
                        <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                            noDataText={itemStatusData.length > 0 ? '' : 'No Data'}
                            dataSource={itemStatusData}
                            showBorders={true}
                            className="customDataTableDesign"
                            height={580}
                            hoverStateEnabled={true}
                            allowColumnResizing={true}
                            allowColumnReordering={true}
                            rowAlternationEnabled={false}
                            showRowLines={true}
                            showColumnLines={false}
                        >
                            <Sorting mode="none"></Sorting>
                            <Export enabled={false} allowExportSelectedData={false} text="Export" />
                            <ColumnHeaderFilter />
                            <LoadPanel enabled={true} />
                            <Paging defaultPageSize={11} />
                            <Pager
                                visible={false}
                                showPageSizeSelector={true}
                                allowedPageSizes={[5, 10, 20, "all"]}
                                showNavigationButtons={true}
                            />
                            <Column cssClass={"cell-highlighted"} fixed={true} dataField="title" caption="" width={120}></Column>
                            <Column dataField="inventoryUnits" caption="Inventory Units (EA)" ></Column>
                            <Column dataField="pieces" caption="Pieces" width={120}></Column>
                            <Column dataField="packages" caption="Packages (PF)" ></Column>
                            <Column dataField="shipment" caption="Shipments" ></Column>
                        </DataGrid>
                    </div>
                </div>
            </div>
        </Popup>
    )
};

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}
export default connect(mapStateToProps)(ItemInventoryStatusPopup);